import { IUser } from 'store/user/interfaces';
import { IOrganization } from '../common/organization/interfaces';

const accessTokenKey = 'accessToken';
const userKey = 'user';
const prevAccessTokenKey = 'prevAccessToken';
const organizationKey = 'organization';
const sessionTypeKey = 'sessionType';

export const getAccessToken = () =>
  localStorage.getItem(accessTokenKey) || undefined;
export const setAccessToken = (v: string) =>
  localStorage.setItem(accessTokenKey, v);
export const removeAccessToken = () => localStorage.removeItem(accessTokenKey);

export const getUser = (): IUser | undefined => {
  const user = localStorage.getItem(userKey);
  return user ? (JSON.parse(user) as IUser) : undefined;
};
export const setUser = (v: string) => {
  localStorage.setItem(userKey, v);
};
export const removeUser = () => {
  localStorage.removeItem(userKey);
};

export const getPrevAccessToken = () =>
  localStorage.getItem(prevAccessTokenKey) || undefined;
export const setPrevAccessToken = (v: string) =>
  localStorage.setItem(prevAccessTokenKey, v);

export const removePrevAccessToken = () =>
  localStorage.removeItem(prevAccessTokenKey);

export const getOrganization = (): IOrganization | undefined => {
  const organization = localStorage.getItem(organizationKey);
  return organization ? (JSON.parse(organization) as IOrganization) : undefined;
};
export const setOrganization = (v: string) => {
  localStorage.setItem(organizationKey, v);
};

export const setSessionType = (sessionType: 'verified' | 'not-verified') =>
  localStorage.setItem(sessionTypeKey, sessionType);
export const getSessionType = () => localStorage.getItem(sessionTypeKey);
export const removeSessionType = () => localStorage.removeItem(sessionTypeKey);

export const clear = () => {
  removeUser();
  removeAccessToken();
  removePrevAccessToken();
  removeSessionType();
};

export const localStorageWrapper = {
  getAccessToken,
  setAccessToken,
  getUser,
  setUser,
  getPrevAccessToken,
  setPrevAccessToken,
  removePrevAccessToken,
  getOrganization,
  setOrganization,
  clear,
  setSessionType,
  getSessionType,
};
